import React from 'react';
import { StyledVerticalContainer } from '../Container';
import { StyledButton, StyledText } from './ButtonActions.styled';

export interface IButtonProps {
	title: string;
	onExit?: () => void;
	onCopy?: () => void;
	onReset?: () => void;
	onResetAll?: () => void;
}

const ButtonActions: React.FC<IButtonProps> = ({
	title,
	onReset,
	onResetAll,
	onCopy,
	onExit,
}) => {
	return (
		<StyledVerticalContainer>
			<StyledText>{title}</StyledText>
			{onReset && <StyledButton onClick={onReset}>Сбросить слой</StyledButton>}
			{onResetAll && (
				<StyledButton onClick={onResetAll}>Сбросить все слои</StyledButton>
			)}
			{onCopy && <StyledButton onClick={onCopy}>Скопировать</StyledButton>}
			{onExit && <StyledButton onClick={onExit}>Выйти</StyledButton>}
		</StyledVerticalContainer>
	);
};

export { ButtonActions };
